export default __webpack_public_path__ + "static/banner-two-shape11-e68d7633b6138ed3264103d16875be8e.png";